import { networkDebounce } from "@/utils/Debouncer";
import { defineStore } from "pinia";
import { useActiveStore as active } from "./active";
import { usePvwStore as pvw } from "./pvw";

// ----------------------------------------------------------------------------
// picking should be debounced.
// ----------------------------------------------------------------------------
let pendingRequest = 0;
const updatePickingDebouncedMethod = () => {
	pendingRequest++;
	if (pendingRequest === 1) {
		return pvw()
			.PVW_EVENT_PICK({
				event: usePickingStore().SSA_PICK_EVENT,
				layerName: active().SSA_ACTIVE_LAYER
			})
			.then((pickedData: any) => {
				usePickingStore().SSA_PICK_DATA_SET(pickedData);

				pendingRequest--;
				if (pendingRequest) {
					// if more were requested while in flight, send another.
					pendingRequest = 0;
					return usePickingStore().SSA_PICK_UPDATE();
				}
			});
	}
};

networkDebounce(
	//  TODO refactor this to support Pinia instead of vuex
	"SSA_PICK_UPDATE",
	"PVW_EVENT_PICK",
	() => usePickingStore().SSA_PICK_EVENT,
	() => active().SSA_ACTIVE_LAYER,
	(pickedData: any) => {
		usePickingStore().SSA_PICK_DATA_SET(pickedData);
	}
);

export const usePickingStore = defineStore("pickingStore", {
	state: () =>
		({
			pickedData: null,
			pickedDataStore: [],
			pickEvent: {},
			pickMode: "NO_PICKING",
			pickHole: false,
			selectionSizes: {},
			pickCsv: "",
			csvVisible: false,
			showPickData: false
		}) as any,
	getters: {
		SSA_SHOW_PICK_DATA(): any {
			return this.showPickData;
		},
		SSA_CSV_VISIBLE(): any {
			return this.csvVisible;
		},
		SSA_CSV_DATA(): any {
			return this.pickCsv;
		},
		SSA_PICK_MODE(): any {
			return this.pickMode;
		},
		SSA_PICK_HOLE(): any {
			return this.pickHole;
		},
		SSA_PICK_POINT_ENABLED(): any {
			return this.pickMode === "point" || this.SSA_PICK_CAMERA_CENTER_ENABLED;
		},
		SSA_PICK_SELECTION_ENABLED(): any {
			const layerState = active().SSA_ACTIVE_LAYER_STATE;
			return (
				this.pickMode.startsWith("select") &&
				layerState &&
				((layerState.userEdits &&
					layerState.userEdits.active &&
					layerState.userEdits.available) ||
					(layerState.selectionExport &&
						layerState.selectionExport.active &&
						layerState.selectionExport.available))
			);
		},
		SSA_PICK_CAMERA_CENTER_ENABLED(): any {
			return this.pickMode === "cameraCenter";
		},
		SSA_PICK_DATA(): any {
			return this.pickedData;
		},
		SSA_PICK_DATA_STORE(): any {
			return this.pickedDataStore;
		},
		SSA_PICK_EVENT(): any {
			return this.pickEvent;
		},
		SSA_SELECTION_SIZES(): any {
			return this.selectionSizes;
		}
	},
	actions: {
		SHOW_PICK_DATA(value: boolean): any {
			this.showPickData = value;
		},
		//mutations from vuex
		SSA_CSV_VISIBLE_SET(value: any): any {
			this.csvVisible = value;
		},
		SSA_PICK_MODE_SET(value: any): any {
			this.pickMode = value;
		},
		SSA_PICK_HOLE_SET(value: any): any {
			this.pickHole = value;
		},
		SSA_PICK_DATA_STORE_SET(value: any): any {
			this.pickedDataStore = value;
		},
		SSA_PICK_DATA_STORE_PUSH(value: any): any {
			for (let i = 0; i < this.pickedDataStore.length; i++) {
				if (this.pickedDataStore[i].id == value.id) {
					Object.assign(this.pickedDataStore[i], value);
					return;
				}
			}
			this.pickedDataStore.push(value);
		},
		SSA_PICK_DATA_STORE_REMOVE(idx: any): any {
			this.pickedDataStore.splice(idx, 1);
		},
		SSA_PICK_DATA_SET(value: any): any {
			this.pickedData = value;
		},
		SSA_PICK_EVENT_SET(value: any): any {
			this.pickEvent = value;
		},
		SSA_CSV_SET(value: any): any {
			this.pickCsv = value;
		},
		//END mutations from vuex
		SSA_PICK_DISABLE(): any {
			this.SSA_PICK_MODE_SET("NO_PICKING");
		},
		SSA_PICK_RESET(): any {
			this.pickedData = null;
			this.pickEvent = {};
			this.pickMode = "NO_PICKING";
			this.pickCameraCenterMode = false;
		},
		SSA_PICK_UPDATE(): any {
			updatePickingDebouncedMethod();
		},
		SSA_SELECTION_SIZE_UPDATE([selectionSize]: [selectionSize: any]): any {
			const { viewId, layerName, selection } = selectionSize;
			if (!this.selectionSizes[viewId]) {
				this.selectionSizes.viewId = { [layerName]: selection };
			} else {
				this.selectionSizes[viewId].layerName = selection;
			}
		}
	}
});
